import * as CONFIG from '../config/regexp_config';

export function minLengthValidator(limit, value) {
  return (value.length < limit && `Minimal length is ${limit}`) || '';
}

export function maxLengthValidator(limit, value) {
  return (value.length > limit && `Maximal length is ${limit} characters`) || '';
}

export function minValidator(limit, value) {
  return numberValidator(value) || (+value < limit && `Minimal value is ${limit}`) || '';
}

export function maxValidator(limit, value) {
  return numberValidator(value) || (+value > limit && `Maximal value is ${limit}`) || '';
}

// type validators

export function numberValidator(value) {
  return (isNaN(+value) && 'Must be a number') || '';
}

// email validator https://stackoverflow.com/a/46181/1460756
export function emailValidator(value) {
  // 2022-06-08 @knowledgemd.com - ban this domain from creating new accounts
  if (String(value).toLowerCase().includes('@knowledgemd.com')) {
    return false;
  }
  const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email.test(String(value).toLowerCase());
}
